import { autoserialize, autoserializeAs } from 'cerialize';

import { BaseDTO, IBaseDTO } from './base-dto';

export class Zone extends BaseDTO implements IZone {
  @autoserialize id?: string;
  @autoserializeAs('created_at') createdAt?: string;
  @autoserializeAs('updated_at') updatedAt?: string;
  @autoserializeAs('partner_id') partnerId?: string;
  @autoserializeAs('charity_id') charityId?: string;
  @autoserializeAs('vehicle_id') vehicle_id?: string;
  @autoserializeAs('store_id') store_id?: string;
  @autoserialize override name: string;
  @autoserialize description: string;
  @autoserialize template_type: string;
  @autoserialize zips: string[];
  @autoserialize meta: any;

  constructor(payload?: IZone) {
    super(payload);
    this.id = payload?.id?.toString();
    this.createdAt = payload?.createdAt;
    this.updatedAt = payload?.updatedAt;
    this.name = payload?.name || '';
    this.description = payload?.description || '';
    this.zips = payload?.zips || [];
    this.meta = payload?.meta;
    this.partnerId = payload?.partnerId?.toString();
    this.charityId = payload?.charityId?.toString();
    this.vehicle_id = payload?.vehicle_id;
    this.store_id = payload?.store_id;
    this.template_type = payload?.template_type;
  }
}

export interface IZone extends IBaseDTO {
  id?: string;
  name?: string;
  description?: string;
  zips?: string[];
  partnerId?: string;
  charityId?: string;
  createdAt?: string;
  updatedAt?: string;
  meta?: any;
  vehicle_id?: string;
  store_id?: string;
  template_type?: string;
}
